module.exports = __webpack_public_path__ + "media/images/map-icons/carA@3x-695ac6bdd621f80a2caf53f1704f9228.png";